import { Link } from 'react-router-dom'

import { useRuntimeConfigStore } from '@/stores/runtime-config-store'

type FooterLink =
  | { label: string; to: string }
  | { label: string; href: string; external?: boolean }

interface FooterGroup {
  title: string
  links: FooterLink[]
}

const footerGroups: FooterGroup[] = [
  {
    title: '产品',
    links: [
      { label: '价格方案', to: '/pricing' },
      { label: '控制台', to: '/tasks' },
      { label: '视频文案提取', to: '/' },
    ],
  },
  {
    title: 'AI 助手',
    links: [{ label: 'SKILL.md', href: '/api/v1/public/skills/dyt-transcribe/SKILL.md' }],
  },
  {
    title: '开发者',
    links: [
      {
        label: 'npm CLI',
        href: 'https://www.npmjs.com/package/dyt-transcribe',
        external: true,
      },
    ],
  },
  {
    title: '法律',
    links: [
      { label: '隐私政策', href: '/privacy' },
      { label: '服务条款', href: '/terms' },
    ],
  },
]

export function ProductFooter() {
  const apiBaseUrl = useRuntimeConfigStore((state) => state.apiBaseUrl)
  const skillHref = `${apiBaseUrl.replace(/\/$/, '')}/public/skills/dyt-transcribe/SKILL.md`

  return (
    <div className="legacy-footer-slot">
      <footer className="legacy-global-footer">
        <div className="legacy-footer-inner">
          <div className="legacy-footer-main">
            <div className="legacy-footer-brand">
              <Link className="legacy-footer-brand-link" to="/" aria-label="Video Transcript 首页">
                <span className="legacy-footer-brand-mark" aria-hidden="true">
                  <img
                    src={`${import.meta.env.BASE_URL}video-transcript-logo.png`}
                    alt=""
                    width="36"
                    height="36"
                  />
                </span>
                <span>Video Transcript</span>
              </Link>
              <p>视频文案提取，粘贴链接即可转文字。</p>
              <p>复制纯文案，保留时间轴，或导出字幕。</p>
            </div>

            <nav className="legacy-footer-nav" aria-label="页脚导航">
              {footerGroups.map((group) => (
                <div className="legacy-footer-group" key={group.title}>
                  <h2>{group.title}</h2>
                  <ul>
                    {group.links.map((link) => {
                      const href = 'href' in link && link.label === 'SKILL.md' ? skillHref : null
                      return (
                        <li key={link.label}>
                          {'to' in link ? (
                            <Link to={link.to}>{link.label}</Link>
                          ) : (
                            <a
                              href={href ?? link.href}
                              target={link.external ? '_blank' : undefined}
                              rel={link.external ? 'noreferrer' : undefined}
                            >
                              {link.label}
                            </a>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              ))}
            </nav>
          </div>
        </div>
      </footer>
    </div>
  )
}
